module.exports = __webpack_public_path__ + "static/img/1_1.396524d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coupon_direction/ios/1_1.jpg
// module id = EzcX
// module chunks = 1